<template>
    <div class="ChoosePage bg_fff">
        <LoginTip :isLogin="user && user.nickname && !iframePage" :renderData="user"/>
        <div class="pd16">
            <p class="co_B0 fs12">对比类型</p>
            <mt-radio class="flex_box mt10" v-model="entity" @change="changeType" :options="typeOptions"></mt-radio>

            <p class="co_B0 fs12 mt24">对比时间</p>
            <p class="noSelect mt10 fs14" :class="{ co_B0: chooseTime.showText.indexOf('请选择') > -1}"
               @click="checkOptions('timeList')">
                {{ chooseTime.showText }}{{ chooseTime | setDateStr }}
                <img src="../assets/img/icon/iconDown.svg" alt="下拉">
            </p>

            <p class="co_B0 fs12 mt24">对比{{ entity == 'company' ? "企业" : "行业" }}</p>
            <section class="flex_box align-items_center selectBox mt10">
                <p class="noSelect fs14 flex_1" :class="{ co_B0: target1.indexOf('请选择') > -1 }"
                   @click="checkOptions(targetKey1)">
                    {{ target1 }}
                    <img src="../assets/img/icon/iconDown.svg" alt="下拉">
                </p>
                <span>VS</span>
                <p class="noSelect fs14 flex_1" :class="{ co_B0: target2.indexOf('请选择') > -1}"
                   @click="checkOptions(targetKey2)">
                    {{ target2 }}
                    <img src="../assets/img/icon/iconDown.svg" alt="下拉">
                </p>
            </section>
            <p class="text_c co_fff footBtnCommon fs18 font_b" @click="toResultPage">开始对比</p>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import _ from "loadsh"
import utils from "@/util/common";
import _co from "@/util/const";

export default {
    name: "ChoosePage",
    components:{
        LoginTip(render){require(["@/components/common/LoginTip"], render)}
    },
    data() {
        return {
            chooseTime: {
                showText: '今日',
                startDate: moment().startOf('day').valueOf(),
                endDate: moment().endOf('day').valueOf(),
            },
            typeOptions: [],
            entity: '', // 被选中的对比类型
            compareTypes: _co.compareTypes,
            targetKey1: 'subIndustries1',
            targetKey2: 'subIndustries2',
            target1: "",
            target2: "",
            pageType: null,
            iframePage: false,
            user: utils.getUser()

        }
    },
    filters: {
        setDateStr(date) {
            let {startDate, endDate} = date;
            if (startDate) {
                return '：' + moment(startDate).format('YYYY年M月D日') + '-' + moment(endDate).format('YYYY年M月D日')
            }
        }
    },
    mounted() {
        // 获取 选择的值
        this.init();
    },
    methods: {
        init(){
            let {type} = this.$route.query;
            this.pageType = type
            if (type === 'compare') {
                document.title = '数据对比'
                this.entity = 'industry';
                this.typeOptions = _.each(this.compareTypes, c => {
                    c.disabled = !this.user
                })
            }

            if (!this.user) {
                this.chooseTime = {
                    showText: '本月',
                    startDate: moment().startOf('month').startOf('day').valueOf(),
                    endDate: moment().endOf('day').valueOf(),
                };
                this.target1 =  _co.defaultIndustryNames[0];
                this.target2=  _co.defaultIndustryNames[1];
                sessionStorage.clear()
            }


            let timeList = sessionStorage.getItem('timeList');
            if (timeList)
                this.chooseTime = JSON.parse(timeList);

            let entity = sessionStorage.getItem('entity');
            if (entity)
                this.entity = entity;

            if(entity == "company"){
                this.target1 = "";
                this.target2 = "";
            }
            this.setTargetKey();
            let target1 = sessionStorage.getItem(this.targetKey1);
            if (target1)
                this.target1 = target1

            let target2 = sessionStorage.getItem(this.targetKey2);
            if (target2)
                this.target2 = target2;
            

        },
        setTargetKey(){
            this.targetKey1 = this.entity == 'company' ? 'companies1' : 'subIndustries1';
            this.targetKey2 = this.entity == 'company' ? 'companies2' : 'subIndustries2';
        },
        checkOptions(pageType) {
            let query = {pageType: pageType}
            if (pageType === 'timeList') {
                query.custom = 'custom';
                query.entity = this.chooseTime.showText;
            }else {
                query.entity = ~['companies1','subIndustries1'].indexOf(pageType) ? this.target1 : this.target2;
            }
            this.$router.push({path: '/optionsPage', query})
        },
        changeType(entity){
            sessionStorage.setItem("entity", entity)
            this.clearStorage();
            this.setTargetKey();
        },
        clearStorage() {
            this.target1 = "";
            this.target2 = "";
            ['companies1', 'companies2', 'subIndustries1', 'subIndustries2', 'TimeList'].forEach(item => {
                sessionStorage.removeItem(item);
            })
        },
        toResultPage() {
            // console.log(this.pageType);
            if (this.pageType === 'compare') {
                let {chooseTime, target1, target2, entity} = this;
                let entityLabel = entity === 'industry' ? '行业' : '企业';
                if (!target1 || !target2) {
                    this.$messagebox({
                        title: '',
                        message: `请选择对比${entityLabel}`,
                    });
                    return;
                }

                if (target1 === target2) {
                    this.$messagebox({
                        title: '',
                        message: `对比${entityLabel}不能相同`,
                    });
                    return;
                }
                if(entity === 'industry'){
                    target1 = _co.industryLabelMap[target1];
                    target2 = _co.industryLabelMap[target2]
                }
                let paramsData = {
                    startDate: chooseTime.startDate,
                    endDate: chooseTime.endDate,
                    targetId1: target1,
                    targetId2: target2,
                    type: this.entity,
                    dateStr: chooseTime.showText !== '自定义月份' ? chooseTime.showText : moment(chooseTime.startDate).format('M月')
                };
                this.$router.push({path: '/compare', query: paramsData})
            }
        }
    },
}
</script>

<style lang="scss" scoped>
.ChoosePage {
    height: 100vh;

    .mt24 {
        margin-top: 24px;
    }

    .radioBox {
        input {
            width: 18px;
            height: 18px;
            // #538DFF
        }
    }

    .noSelect {
        height: 40px;
        line-height: 40px;
        border: 1px solid #C9C9CA;
        border-radius: 2px;
        position: relative;
        text-indent: 8px;

        img {
            width: 16px;
            position: absolute;
            top: 12px;
            right: 8px;
        }
    }

    .selectBox {
        span {
            margin: 0 9px;
        }
    }
}

</style>